import { defineAIProviderManifest } from "../manifest";
import { buildOciBaseUrl, regionFromBaseUrl } from "./credentials";

export const manifest = defineAIProviderManifest({
  id: "oracle-oci",
  label: "Oracle Cloud Infrastructure",
  description:
    "Connect to Oracle Cloud Infrastructure Generative AI. Requests are signed by a connector.",
  connectorIdentifier: "oracleOci",
  defaultChatModel: "xai.grok-4.20-0309-non-reasoning",
  defaultFastModel: "xai.grok-4.20-0309-non-reasoning",
  configurable: true,
  requiresChatModel: true,
  credentialFields: [
    {
      key: "region",
      label: "Region",
      description: "Required. Your OCI region slug, e.g. us-chicago-1.",
      placeholder: "us-chicago-1",
      required: true,
    },
    {
      key: "apiKey",
      label: "API key",
      description: "Supplied by the connector.",
      placeholder: "",
      sensitive: true,
      required: true,
    },
  ],
  packCredentials: (v) => ({
    baseUrl: buildOciBaseUrl(v.region ?? ""),
    apiKey: "",
  }),
  unpackCredentials: (row) => ({
    region: regionFromBaseUrl(row.baseUrl),
    apiKey: "",
  }),
  subtitleField: "region",
});
